const home = {
	overview_cards: {
		dadup: {
			go_to: "Go to daDup overview",
			title: "daDup",
		},
		domain: {
			go_to: "Go to domain overview",
			title: "Domains",
		},
		pbs: {
			go_to: "Go to PBS overview",
			title: "PBS",
		},
		vps: {
			go_to: "Go to VPS overview",
			title: "VPSes",
		},
	},
	welcome: "Welcome",
};

export default home;
